import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Button, Paper } from "@mui/material";
import { useState, useRef } from "react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useTranslation } from "react-i18next";
import "./ConfirmationModal.css";
import {
  DELETE_BTN,
  NOTIFICATION_ICON,
  DELETE_ICON,
  CANCEL_BTN,
} from "../../../utils/constants";
import EventManager from "../../../utils/managers/EventManager";
import toast from "react-hot-toast";
import { CONFIRMATION_MODAL } from "../../../utils/constants";

const ConfirmationModal = ({ setIsDeleteConfirmationWindowVisible, id }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [iconSlide, setIconSlide] = useState(false);
  const deleteBtn = useRef(null);

  const { t } = useTranslation();

  function deleteAnimation() {
    if (deleteBtn.current) {
      const iconSlide = deleteBtn.current.getBoundingClientRect().width;
      setIconSlide(iconSlide / 2 - 20);
    }
    setTimeout(() => {
      setIsClicked(true);
    }, 200);
  }

  async function deleteEvent() {
    const result = await EventManager.deleteEvent(id);

    if (result === "success") {
      toast.success(t("deleteToastMessage.success"));
    } else {
      toast.error(t("deleteToastMessage.fail"));
    }
  }

  return (
    <div className="card__modal-window-wrapper">
      <Paper
        sx={CONFIRMATION_MODAL}
        className="card__modal-window-wrapper__modal-window"
      >
        <div className="card__modal-window-wrapper__modal-window__message">
          <ErrorOutlineRoundedIcon sx={{ ...NOTIFICATION_ICON }} />
          <p>{t("confirmDelete")}</p>
        </div>
        <div className="card__modal-window-wrapper__modal-window__buttons-wrapper">
          <Button
            variant="outlined"
            onClick={() => setIsDeleteConfirmationWindowVisible(false)}
            sx={CANCEL_BTN}
          >
            {t("cancelBtn")}
          </Button>
          <Button
            ref={deleteBtn}
            onClick={() => {
              deleteAnimation();
              deleteEvent();
              setTimeout(() => {
                setIsDeleteConfirmationWindowVisible(false);
                document.documentElement.style.overflow = "auto";
              }, 1500);
            }}
            endIcon={
              <DeleteOutlineOutlinedIcon
                sx={{
                  ...DELETE_ICON,
                  transform: isClicked
                    ? `translate(-${iconSlide}px) scale(1.2)`
                    : "",
                  opacity: isClicked ? "1" : "0",
                }}
              />
            }
            sx={{
              ...DELETE_BTN,
              color: isClicked ? "rgba(0, 0, 0, 0)" : "red",
            }}
            variant="outlined"
          >
            {t("deleteBtn")}
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default ConfirmationModal;
